
import ICommit from '../contracts/commit'

import auth from '../../services/auth'
import hosts from '../../services/hosts'

const TOKEN_KEY = 'occ-key-token'
const USER_KEY = 'occ-key-user'
// const ACL_KEY = 'occ-key-wolf'

const baseState = {
  user: JSON.parse(localStorage.getItem(USER_KEY) || '{}'),
  token: localStorage.getItem(TOKEN_KEY)
  // wolf: JSON.parse(localStorage.getItem(ACL_KEY) || '{}')
}

const persistAndCommitSession = (commit: any, session: any) => {
  localStorage.setItem(TOKEN_KEY, session.token)
  localStorage.setItem(USER_KEY, JSON.stringify(session.user))
  // localStorage.setItem(ACL_KEY, JSON.stringify(session.wolfProduct))

  commit('setSession', session)
  return session
}
const actions = {
  signIn ({ commit }: ICommit, credentials: any) {
    return auth.signIn(credentials)
      .then((session) => persistAndCommitSession(commit, session))
  },
  signOut ({ commit }: ICommit) {
    return auth.signOut()
      .then(() => {
        localStorage.removeItem(TOKEN_KEY)
        localStorage.removeItem(USER_KEY)
        // localStorage.removeItem(ACL_KEY)
        commit('clearSession')
      })
  },
  sso ({ commit }: ICommit, session: any) {
    persistAndCommitSession(commit, session)
    return auth.sso()
      .then((res: any) => {
        if (!res.id) {
          localStorage.removeItem(TOKEN_KEY)
          localStorage.removeItem(USER_KEY)
          // localStorage.removeItem(ACL_KEY)
          commit('clearSession')
          return
        }
        session.user = res
        persistAndCommitSession(commit, session)
      })
  },
  isValid () {
    return auth.isValid()
      .catch(err => {
        if (err) return false
      })
  },
  getLiderazgoHost () {
    return hosts.getOne('LIDERAZGO360')
      .catch(err => {
        if (err) return false
      })
  },
  getSuiteHost () {
    return hosts.getOne('suite')
      .catch(err => {
        if (err) return false
      })
  },
  getSuiteWebHost () {
    return hosts.getOne('suite')
      .then(res => {
        if (res && res.clientUrl) {
          let urlSuite = res.clientUrl
          if (res.clientPort && res.clientPort !== 80 && res.clientPort !== 443) {
            urlSuite = `${urlSuite}:${res.clientPort}`
          }
          return urlSuite
        }
      })
      .catch(err => {
        if (err) return false
      })
  }
}

const mutations = {
  setSession (state: any, session: any) {
    state.user = session.user
    state.token = session.token
    // state.wolf = session.wolf
  },
  clearSession (state: any) {
    state.user = {}
    // state.wolf = {}
    state.token = null
  }
}

export default {
  namespaced: true,
  state: baseState,
  actions,
  mutations
}
